import { create } from 'zustand'

export type DriverRouteProperties = {
  color: string
  arrow: string
  isVisible: boolean
}

export type DriverTrackingState = {
  selectedDriverId: string | null // The ID of the currently selected driver
  driverOrdersOnRoute: {
    [orderNumber: number]: DriverRouteProperties
  }
}

export const useDriverTrackingState = create<DriverTrackingState>((set) => ({
  selectedDriverId: null,
  driverOrdersOnRoute: {},
}))

export * as actions from './actions'
